import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  inputs: {
    position: 'relative',
    padding: '1.25rem 3rem',
    width: '50%',
  },
  content: {
    borderLeft: '1px solid #dbdbdb',
    width: '50%',
    height: '100%',
    backgroundColor: theme.palette.colors.mediumLightGrey,
    overflowY: 'scroll',
  },
  generationWrapper: {
    padding: '1rem 3rem',
    height: '100%',
  },
  docsCounter: {
    display: 'flex',
    justifyContent: 'center',
  },
  docsNav: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  preview: {
    width: '300px',
    margin: '0px auto 20px auto',
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
  previewIcon: {
    transform: 'rotate(20deg)',
    color: theme.palette.primary.main,
    margin: '2px 10px 0px 10px',
  },
  export: {
    width: '150px',
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
  generateWrap: {
    marginTop: theme.spacing(2.5),
  },
  newButton: {
    fontFamily: '"Inter", sans-serif',
    padding: '5px 10px',
    outline: 'none',
    borderRadius: theme.border.radius.default,
    background: 'white',
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    fontSize: '16px',
    marginHorizontal: 'auto',
    cursor: 'pointer',
    transition: 'all 250ms',
    '&: hover, :focus': {
      opacity: 0.8,
    },
    width: '130px',
    marginRight: '0.5rem',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
}));
